// skeleton loader js

  setTimeout(function(){
    // skeleton class removed.
    if( $('.skeleton-body').length > 0 ){
      // $('div').removeClass('skeleton');
      // $('p').removeClass('skeleton');
      // $('a').removeClass('skeleton');
      // $('h1').removeClass('skeleton');
      // $('h2').removeClass('skeleton');
      // $('h3').removeClass('skeleton');
      // $('button').removeClass('skeleton');
      // $('span').removeClass('skeleton');      
      $('body').removeClass('body_skeleton');
    }
    if( $('.loader').length > 0 ){
      // $('div').removeClass('skeleton');
      // $('p').removeClass('skeleton');
      // $('a').removeClass('skeleton');
      // $('h1').removeClass('skeleton');
      // $('h2').removeClass('skeleton');
      // $('h3').removeClass('skeleton');
      // $('button').removeClass('skeleton');
      // $('span').removeClass('skeleton');
      $('.loader').css({"display":"none"});
      $('.loader').children('img').remove();
      $('body').removeClass('body_skeleton');
    }
    
  },200);
function updateSizeOptions() {
  console.log('== custom.js == updateSizeOptions() ==');
  $('.ProductForm__Variants .SizeSwatchList li').removeClass('showOption');
  // console.log('we are in updateSizeOptions...')
  if($('.ProductForm__Variants .ColorSwatchList').length > 0) {
    // console.log('we are in updateSizeOptions...if part ....')
    var selectedOption1 = $('.ProductForm__Variants .ColorSwatchList :radio:checked').val().trim();
    // console.log("selected option 1",selectedOption1);
     let home = 'home' ;
    $('select[name="id"] option[data-option_1="'+selectedOption1+'"]').each(function(){
      // console.log('we are in updateSizeOptions...inside inner loop ....')
      $('.ProductForm__Variants .SizeSwatchList :radio[value="'+$(this).attr('data-option_2')+'"]').closest('li').addClass('showOption');
    });
  } else {
    // console.log('we are in updateSizeOptions...else part ....')
    $('.ProductForm__Variants .SizeSwatchList :radio').closest('li').addClass('showOption');
  }
  $('ul.SizeSwatchList.HorizontalList .HorizontalList__Item').each(function(){
    if(!$(this).hasClass('showOption')){
      // console.log("shw element::",$(this));
      $(this).css('opacity','1');
      $(this).addClass('showOption');
      $(this).children('label').addClass('strikethrough');
      $(this).children('input').addClass('strikethrough-input');
    }
  });
  $('.SizeSwatch').each(function(){
    if($(this).hasClass('strikethrough')){
      // console.log('data-value==>', $(this).attr('data-value'));
      $(`.size_selectswatch-small-pdp[data-value="${$(this).attr('data-value')}"]`).addClass('strikethrough');
    }
  });
}
// updateSizeOptions()


$(document).on('click','.ProductForm__Variants .ColorSwatchList li', function(){
  // console.log('test');
  //updateSizeOptions();
  $.when( updateSizeOptions() ).done(function() {
    
    if( $('#shopify-section-landing-featured-product').length > 0 ){
      
      var $currColor = $('.ProductForm__Variants .ProductForm__Option[data-option="color"]').find('.ColorSwatchList .HorizontalList__Item').find('.ColorSwatch__Radio:checked').val();
      var $currSize = $('.ProductForm__Variants .ProductForm__Option[data-option="size"]').find('.SizeSwatchList .HorizontalList__Item').find('.SizeSwatch__Radio:checked').val();
      if($currColor != undefined){
        $('.ProductForm__Variants').find('.ProductForm__Option[data-option="color"]').find('.ProductForm__Label .sc_colour').html($currColor);
        // console.log('$currColor=',$currColor);
        // console.log('$currSize=',$currSize);
        $('.ProductForm__Variants .no-js.ProductForm__Option select[name="id"] option:not([disabled="disabled"])').each(function(){
          var $this = $(this);
          var $color = $this.data('color');
          var $size = $this.data('size').split("/");
          // console.log('$size',$size);
          $size = $.trim($size[1]);
          if( $currColor == $color ){
            // console.log('$color=',$color);
            // console.log('$size=',$size);
            $('.ProductForm__Variants .ProductForm__Option[data-option="size"] .SizeSwatchList .HorizontalList__Item').each(function(){
              var $this1 = $(this);
              $this1.find('.SizeSwatch__Radio[value="'+$size+'"]').removeClass('strikethrough-input');
              $this1.find('.SizeSwatch[data-value="'+$size+'"]').removeClass('strikethrough');
              // console.log('$this1',$this1);
            });
          }
        });
      }
      
      // change curr select option
      setTimeout(function(){
        currVariant();
      },100);
      
    }
    
  });
});


function currVariant(){
  console.log('== custom.js == currVariant() ==');
  if( $('#shopify-section-landing-featured-product').length > 0 ){
    
      //$.when( 
        
        console.log('fn currVariant:');
        $('.ProductForm__Variants').find('.no-js.ProductForm__Option').find('select[name="id"] option').removeAttr('selected');
        
        var $currColor = $('.ProductForm__Variants .ProductForm__Option[data-option="color"]').find('.ColorSwatchList .HorizontalList__Item').find('.ColorSwatch__Radio:checked').val();
        var $currSize = $('.ProductForm__Variants .ProductForm__Option[data-option="size"]').find('.SizeSwatchList .HorizontalList__Item').find('.SizeSwatch__Radio:checked').val();  
        // console.log('fn $currColor=',$currColor);
        console.log('fn $currSize==>',$currSize);
        if($currSize != undefined){
          $('.ProductForm__Variants').find('.ProductForm__Option[data-option="size"]').find('.ProductForm__Label .sc_size').html($currSize.split(" ")[1]);
          var $newVariant = $currColor+' / '+$currSize;
          console.log('fn $newVariant=',$newVariant);
          $('.ProductForm__Variants').find('.no-js.ProductForm__Option').find('select[name="id"] option[data-size="'+$newVariant+'"]').prop('selected', 'selected').change();
          
          // check new selection is disabled / OOS then remove size selection.
          if( $('select[name="id"] option:selected').is(':disabled') == true ){
            console.log('fn $newVariant= disabled',$currSize);
            $('.ProductForm__Variants .ProductForm__Option[data-option="size"]').find('.SizeSwatchList .HorizontalList__Item').find('.SizeSwatch__Radio[value="'+$currSize+'"]').prop('checked', false).change();
            $('.ProductForm__Variants .ProductForm__Option[data-option="size"]').find('.SizeSwatchList .HorizontalList__Item').find('.SizeSwatch__Radio:not(.strikethrough-input)').first().trigger('click');
          }
        }
          
     //).done(function() {
          
      // Change URL in title with current Variant ID
      var currVariantID = $('select[name="id"] option:selected').val(); //  $('select[name="id"]').val();
      console.log('fn currVariantID=',currVariantID);
      var addURL = $('.ProductMeta__Title').find('a').attr('href');
      if(addURL !='undefined'){
        if (addURL.indexOf("?variant=") > -1) {
          var queryURL = addURL.split("?");
          var prodURL = queryURL[0];
          console.log('found',);
          $('.ProductMeta__Title').find('a').attr('href', prodURL+'?variant='+currVariantID);
          $('.FeaturedProduct__GalleryContainer').find('.slick-track').find('a.slick-slide').attr('href', prodURL+'?variant='+currVariantID);
          $('.FeaturedProduct__Info').find('.ProductForm').find('#viewBtn').attr('href', prodURL+'?variant='+currVariantID);
        } else {
          $('.ProductMeta__Title').find('a').attr('href', addURL+'?variant='+currVariantID);
          $('.FeaturedProduct__GalleryContainer').find('.slick-track').find('a.slick-slide').attr('href', addURL+'?variant='+currVariantID);
          $('.FeaturedProduct__Info').find('.ProductForm').find('#viewBtn').attr('href', addURL+'?variant='+currVariantID);
        }
      }
    
    
    //});
  }
  
}
currVariant();


// size swatch click
if( $('#shopify-section-landing-featured-product').length > 0 ){
  $(document).on('click','.ProductForm__Variants .SizeSwatchList li', function(){
    // console.log('fn size currVariant:');
    // change curr select option
    currVariant();
  });
}


$(document).ready(function(){
  
  $.when( updateSizeOptions() ).done(function() {
    // filterFeaturedGallery();
  
    // After load first color click
    if( $('#shopify-section-landing-featured-product').length > 0 ){
      if( $('.ColorSwatchList .HorizontalList__Item').length > 0 ){
        $('.ProductForm__Variants .ProductForm__Option[data-option="color"]').find('.ColorSwatchList .HorizontalList__Item:first').find('.ColorSwatch__Radio').trigger('click');
      }
    }
    
  });

  // window scroll landing page hide ATC sticky pointing button
  $(window).scroll(function(){
    if( $('.landing-featured-product').length > 0 && $('.landing-fixed-btn').length > 0 ){
      var landingWrap = document.querySelector(".landing-featured-product") || null;

      if(landingWrap){
        //let $top = landingWrap.offsetTop - window.outerHeight;
        var secID = $('.landing-featured-product').data('section-id');
        //console.log('secID',secID);
        var $top = $('.landing-featured-product[data-section-id="'+ secID +'"]').offset().top - window.outerHeight;
        let $topForRemove = landingWrap.offsetTop + landingWrap.clientHeight;
  
         // console.log("scrollled",window.scrollY);
         // console.log("top",$top);
         // console.log("topForRemove",$topForRemove);
      
        if($top < window.scrollY && $topForRemove > window.scrollY){
          //console.log("scrollled",window.scrollY);
          if(document.querySelector(".landing-fixed-btn")) document.querySelector(".landing-fixed-btn").classList.add("hide");
        }else{
          if(document.querySelector(".landing-fixed-btn.hide")) document.querySelector(".landing-fixed-btn").classList.remove("hide");
        }
      }
    }
  });
});
/**/

// $(document).ready(function() {
//   $("body .ajx-color-swatch").on("click", function(event) {
//     event.preventDefault();
    
//     var handle = $(this).attr('href');
    
//     $.get(handle + '?view=ajax_featured_collection_new', function(data) {
//       $(this).parents('.Carousel__Cell_cus_new').html(data);
      
//     }.bind(this));
//   });
// });



